export default "__VITE_ASSET__0yH3lJAX__"